










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
  computed: {},
})
export default class TrialCancellationContainer extends Vue {
  @Prop() title: string | undefined;
  @Prop() subtitle: string | undefined;
}
